<template>
  <v-row class="c-black" justify-space-between="">
    <v-col class="py-3" sm="9">
      <v-btn @click="ageDialogIsVisible=true" class="c-black bg-white b-radius-4 bc-pale-gray h-30 mr-1" color="secondary" outlined="">
        <span class="d-none d-md-flex">{{ searchAge }} old</span>
        <v-icon class="c-dark-blue d-flex d-md-none">cake</v-icon>
      </v-btn>

      <v-btn @click="coverageDialogIsVisible=true" class="c-black bg-white b-radius-4  bc-pale-gray h-30 mr-1" color="secondary" outlined="">
        <span class="d-none d-md-flex">{{ searchCoverage }}</span>
        <v-icon class="c-dark-blue d-flex d-md-none">access_time</v-icon>
      </v-btn>

      <v-btn @click="openLocationDialog()" class="bg-white b-radius-4 bc-pale-gray c-black h-30" color="secondary" outlined="">
        <span class="d-none d-md-flex">{{ searchLocation }}</span>
        <v-icon class="c-dark-blue d-flex d-md-none">person_pin</v-icon>
      </v-btn>
    </v-col>

    <v-col class="d-md-none ta-right">
      <v-btn :class="mapClass" @click="$emit('swap', 'map')" class="w-30 mr-0 b-radius-0" depressed="">
        <v-icon>map</v-icon>
      </v-btn>

      <v-btn :class="listClass" @click="$emit('swap', 'list')" class="w-30 ml-0 b-radius-0 pxy-0" depressed="">
        <v-icon>list </v-icon>
      </v-btn>
    </v-col>

    <v-dialog v-model="ageDialogIsVisible" width="600px">
      <v-card class="px-4">
        <v-card-text>
          <b-search-ages :search="search"></b-search-ages>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="ageDialogIsVisible=false" text="">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="updateSearch()" text="">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="coverageDialogIsVisible" width="600px">
      <v-card class="px-4">
        <v-card-text>
          <b-search-coverage :search="search"></b-search-coverage>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="coverageDialogIsVisible=false" text="">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="updateSearch()" text="">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="locationDialogIsVisible" width="600px">
      <v-card class="px-4">
        <v-card-text>
          <b-search-location :search="search"></b-search-location>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="locationDialogIsVisible=false" text="">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="updateSearch()" text="">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import SearchCoverage from './coverage.vue'
import SearchAges from './ages.vue'
import SearchLocation from './location.vue'

export default {
  components: {
    'b-search-ages': SearchAges,
    'b-search-coverage': SearchCoverage,
    'b-search-location': SearchLocation,
  },

  computed: {
    searchAge: function() {
      return this.age(this.search.min_age) + " - " + this.age(this.search.max_age)
    },

    searchCoverage: function() {
      var str = []
      var weekdays = this.search.coverage.split(",")
      for(var d in weekdays) {
        str.push(this.shortDays[weekdays[d]])
      }
      return str.join(", ")
    },

    searchLocation: function() {
      if(!(this.search.origin && this.search.destination && this.search.location_type == 'commute')) {
        var point = this.search.origin || this.search.destination
        return point.city + ", " + point.state
      } if(this.search.origin.city == this.search.destination.city) {
        return this.search.origin.city + ", " + this.search.origin.state
      } else {
        return this.search.origin.city + " - " + this.search.destination.city
      }
    },

    listClass: function() {
      if(this.mode == 'list') {
        return this.active
      } else {
        return this.inactive
      }
    },

    mapClass: function() {
      if(this.mode == 'map') {
        return this.active
      } else {
        return this.inactive
      }
    }
  },

  data: function() {
    return {
      active: ['bg-dark-blue', 'text', 'c-white'],
      shortDays: {
        "0": "M", "1": "Tu", "2": "W", "3": "Th", "4": "F"
      },
      ageDialogIsVisible: false,
      coverageDialogIsVisible: false,
      locationDialogIsVisible: false,
      inactive: ['bg-white', 'outlined', 'c-dark-blue']
    }
  },

  methods: {
    age: function(months) {
      if(months == 0) {
        return "0"
      } else if (months >= 72) {
        return "6 years +"
      }
      var years = Math.round(months / 12)
      months = months % 12
      var str = []
      if(years >= 1) {
        str.push(years + " years")
      }
      if(months >= 1) {
        str.push(months + " months")
      }
      return str.join(" ")
    },

    newDaysMap: function() {
      var map = new Map()
      map.set(0, "M")
      map.set(1, "Tu")
      map.set(2, "W")
      map.set(3, "Th")
      map.set(4, "F")
      return map
    },

    openLocationDialog: function() {
      this.locationDialogIsVisible=true
      this.$emit('redraw')
    },

    updateSearch: function() {
      this.$emit('update')
      this.editAgesMenuIsVisible = false
      this.editCoverageMenuIsVisible = false
      this.editLocationMenuIsVisible = false
    }
  },

  props: ['mode', 'search']
}
</script>
